import { render } from "./app-notification.vue?vue&type=template&id=7f2be754&ts=true"
import script from "./app-notification.vue?vue&type=script&lang=ts"
export * from "./app-notification.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\src\\BusinessLuchs_CRM\\frontend-dispatcher\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__